import { h } from 'preact';

import { connect } from 'redux-zero/preact';

import PTResult from './result/PT';
import ETResult from './result/ET';

const mapToProps = ({type}) => ({type});

const Result = (props) => {
    return (
        props.type == 'et' ? <ETResult/> : <PTResult/>
    )
}

export default connect(mapToProps,null)(Result)